"use strict";
// SPDX-FileCopyrightText: 2024 Red Bee Media Ltd <https://www.redbeemedia.com/>
//
// SPDX-License-Identifier: MIT
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSamsungAdapter = void 0;
/// <reference types="tizen-common-web" />
/// <reference types="tizen-tv-webapis" />
const js_player_shared_1 = require("@ericssonbroadcastservices/js-player-shared");
const common_1 = require("../common");
function hasWebapis() {
    return !!document.querySelector('script[src="$WEBAPIS/webapis/webapis.js"]');
}
function getSamsungAdapter() {
    if (!(0, common_1.isSamsungTV)()) {
        return;
    }
    if (!hasWebapis()) {
        console.warn("[RedBeeMedia] You are using a Samsung TV, but the webapis script is not loaded. The player may not function properly.");
        return;
    }
    return () => __awaiter(this, void 0, void 0, function* () {
        const tizenVersion = tizen.systeminfo.getCapability("http://tizen.org/feature/platform.version");
        const modelNumber = webapis.productinfo.getRealModel();
        return {
            id: (0, js_player_shared_1.getDeviceId)(),
            type: "ctv",
            name: `SamsungTV ${modelNumber}`,
            manufacturer: "samsung",
            model: `samsung-tv-${tizenVersion}`,
            modelNumber,
            os: "Tizen",
            osVersion: tizenVersion,
        };
    });
}
exports.getSamsungAdapter = getSamsungAdapter;
//# sourceMappingURL=samsung.js.map